export default __webpack_public_path__ + "static/media/cslabs-logo.00624aa7.svg";